import React from 'react';
import LayoutDashboard from 'app/private/layout';
import styled from 'styled-components';
// import Section from 'components/layout/section';
// import EmptySpace from 'stories/components/empty-space';
import useAppBarTitle from 'hooks/use-app-bar-title';
import { H6 } from 'components/typography';

const DashboardCardsLayout = styled.div`
    display: grid;
    gap: 2rem;
    grid-template-columns: max-content max-content;
`;

const pageTitle = 'Dashboard';

const Dashboard = () => {
    useAppBarTitle(pageTitle);

    return (
        <LayoutDashboard>
            <DashboardCardsLayout>
                <H6>Welcome</H6>
                {/*1
                <Section title={'Section 1'}>
                    <EmptySpace width={'25rem'} height={'10rem'} />
                </Section>
                <Section title={'Section 2'}>
                    <EmptySpace width={'25rem'} height={'10rem'} />
                </Section>
                <Section title={'Section 3'}>
                    <EmptySpace width={'25rem'} height={'10rem'} />
                </Section>
                <Section title={'Section 4'}>
                    <EmptySpace width={'25rem'} height={'10rem'} />
                </Section>
                */}
            </DashboardCardsLayout>
        </LayoutDashboard>
    );
};

export default Dashboard;
